var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.route ? 'RouterLink' : 'a',_vm._b({tag:"component",class:_vm.$style.link},'component',_vm.linkProps,false),[_c('IconSelect',{class:_vm.$style.icon,attrs:{"icon":_vm.icon,"icon-props":{ 'stroke-width': 1 }}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }